import { render, staticRenderFns } from "./RequerimientoNumerical.vue?vue&type=template&id=63b782a7&"
import script from "./RequerimientoNumerical.vue?vue&type=script&lang=js&"
export * from "./RequerimientoNumerical.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextarea } from 'vuetify/lib'
installComponents(component, {
  VTextarea,
})
